export const valuesData = [
   "Positive energy.",
   "Everyone deserves a chance to grow.",
   "Focus on fundamentals.",
   "Build life-long friendships.",
   "Treat and compensate coaches as professionals."
];

export const missionData = [
   "606 Academy is a proud  501(c)(3) Nonprofit Organization that uses sports as the vehicle to influence and inspire those around us. Players build life-long, supportive friendships that help them — and others — persevere through adversity."

]